import { Box, Grid2, Stack, Typography, useTheme } from '@mui/material';
import EthiquinNoData from '../../../../../assets/images/Ethiquin/ethiquin_no_data.svg';
import { useTranslation } from 'react-i18next';

export const InvestigationAdvertisement = ({ title, description }) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();

  return (
    <Box padding={2}>

      <Grid2
        container
        spacing={2}
      >
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <Typography component="h4" fontSize={28} marginBottom={2.7} color={theme.palette.pink.main}>
            {title ?? t("advertisement.title")}
          </Typography>

          <Typography>
            {description ?? t("advertisement.description")}
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <img
            style={{ width: '100%', height: '140px' }}
            src={EthiquinNoData}
            alt="Nodata"
          />
        </Grid2>
      </Grid2>

    </Box>
  )
}
